import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/offers/:offerId/parcels/:parcelId',
    component: () => import('../pages/ParcelDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'parcelDetailsBaseDataTab',
        path: '',
        component: () => import('../pages/ParcelDetailsBaseDataPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'proPlantaTab',
        path: 'proplanta',
        component: () => import('../pages/ProPlantaPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/offers/:offerId/parcels/:parcelId/maximap',
    component: () => import('../pages/ParcelMaxiMapDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    },

    children: [
      {
        name: 'parcelMaxiMapDetailsBaseDataTab',
        path: '',
        component: () => import('../pages/ParcelMaxiMapDetailsBaseDataPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'ownParcels',
    path: '/own-parcels',
    component: () => import('../pages/OwnParcelsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/own-parcels/:parcelId',
    component: () => import('../pages/OwnParcelDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'ownParcelDetailsBaseDataTab',
        path: '',
        component: () => import('../pages/OwnParcelDetailsBaseDataPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'ownProPlantaTab',
        path: 'proplanta',
        component: () => import('../pages/OwnProPlantaPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
